import { EVENT_STATUSES } from './constatnts'

export const FILTERS_CONFIG = [
  {
    key: 'status',
    label: 'events.status.selectStatus',
    options: EVENT_STATUSES || [],
    placeholder: 'Select status',
  },
]
